"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findElement = exports.selectOneFromFilter = exports.getDistrictFilteredData = exports.getStateFilteredData = exports.trimAddressNamePrefix = exports.concatAddressNameWithPrefix = exports.getDistrictName = exports.getStateName = exports.handleQueryChange = exports.handleFilterStateDistricts = exports.hasAvailableFreePost = exports.groupByPostAvailability = exports.groupByDistrictsByState = exports.getStateNameById = exports.createQueryUrl = exports.hasAppliedFilters = exports.getAppliedFiltersCount = exports.GeometryArrayParam = exports.extractStateDistrictFromPlace = exports.getPostListingTitle = void 0;
var lodash_1 = __importDefault(require("lodash"));
var query_string_1 = require("query-string");
var use_query_params_1 = require("use-query-params");
var GeneralSettings_1 = require("../constants/GeneralSettings");
var strings_1 = require("./strings");
var PostViewContentTypes_1 = require("../constants/PostViewContentTypes");
var SearchParamsMapping_1 = require("../constants/SearchParamsMapping");
var Localization_1 = require("../constants/Localization");
var getPostListingTitle = function (translation, locationPathName, query, filters, lang) {
    var _a;
    var unSelectState = translation('SEARCH_SUMMARY.apartment_' + Localization_1.PagePrefix[locationPathName]);
    if ((_a = query.state) === null || _a === void 0 ? void 0 : _a.length) {
        var selectedStates = filters.state.options.reduce(function (acc, item) {
            if (query.state.includes(String(item.govId))) {
                return __spreadArray(__spreadArray([], acc), [item.translations[lang]]);
            }
            return acc;
        }, {});
        return unSelectState + ',' + selectedStates;
    }
    return unSelectState + ',' + translation('SEARCH_SUMMARY.country');
};
exports.getPostListingTitle = getPostListingTitle;
var extractStateDistrictFromPlace = function (place) {
    var address_components = place.address_components;
    var district = '', placeAdministrative = '', placeLocality = '', placeSubLocality = '';
    address_components.forEach(function (component) {
        var types = component.types;
        if ((types === null || types === void 0 ? void 0 : types.indexOf('administrative_area_level_1')) > -1 ||
            (types === null || types === void 0 ? void 0 : types.indexOf('administrative')) > -1) {
            placeAdministrative = component.short_name;
        }
        if ((types === null || types === void 0 ? void 0 : types.indexOf('locality')) > -1 ||
            (types === null || types === void 0 ? void 0 : types.indexOf('secondary')) > -1) {
            placeLocality = component.short_name;
        }
        if ((types === null || types === void 0 ? void 0 : types.indexOf('sublocality_level_1')) > -1) {
            placeSubLocality = component.short_name;
        }
    });
    var state = strings_1.formatToSnakeCase(placeAdministrative);
    if (placeLocality === placeAdministrative) {
        district = strings_1.formatToSnakeCase(placeSubLocality);
    }
    else {
        district = strings_1.formatToSnakeCase(placeLocality);
    }
    return {
        state: state,
        district: district,
    };
};
exports.extractStateDistrictFromPlace = extractStateDistrictFromPlace;
exports.GeometryArrayParam = {
    encode: function (arr) {
        if (!arr) {
            return undefined;
        }
        if (arr.length === 0 || (arr[0] && arr[0].length === 0)) {
            return null;
        }
        var pointArr = [];
        arr.forEach(function (polygon) {
            pointArr.push(polygon
                .map(function (point) {
                return point.join('-');
            })
                .join('~'));
        });
        return use_query_params_1.encodeDelimitedArray(pointArr);
    },
    decode: function (arrStr) {
        if (!arrStr) {
            return null;
        }
        var decodedArr = use_query_params_1.decodeDelimitedArray(arrStr);
        if (lodash_1.default.isArray(decodedArr)) {
            var parsedArr = decodedArr.map(function (str) {
                return str === null || str === void 0 ? void 0 : str.split('~').map(function (s) { return s.split('-'); });
            });
            return [parsedArr];
        }
        return [decodedArr];
    },
};
var getAppliedFiltersCount = function (filters) {
    var ignore = GeneralSettings_1.GENERAL_SETTINGS.FILTERS.IGNORE_ON_COUNT;
    var count = 0;
    for (var filterKey in filters) {
        if (ignore.indexOf(filterKey) === -1) {
            if (lodash_1.default.isArray(filters[filterKey]) &&
                filters[filterKey].length > 0) {
                count++;
            }
            else if (lodash_1.default.isString(filters[filterKey]) &&
                filters[filterKey] != '') {
                count++;
            }
        }
    }
    return count;
};
exports.getAppliedFiltersCount = getAppliedFiltersCount;
var hasAppliedFilters = function (filters) {
    return lodash_1.default.some(filters, function (value, key) {
        if (lodash_1.default.isArray(value)) {
            return !!value.length;
        }
        if (lodash_1.default.isString(value)) {
            return value !== '';
        }
        return false;
    });
};
exports.hasAppliedFilters = hasAppliedFilters;
/**
 * Converts object to query string based on defined search query mapping
 * @param searchParams
 * @returns {string}
 */
var createQueryUrl = function (searchParams) {
    var obj = {};
    var values = {};
    Object.keys(SearchParamsMapping_1.SearchParamsMapping).forEach(function (param) {
        var type = SearchParamsMapping_1.SearchParamsMapping[param].type;
        if (searchParams[param]) {
            obj[param] = type;
            values[param] = searchParams[param];
        }
        if (param === 'customViewBox') {
            obj[param] = exports.GeometryArrayParam;
        }
    });
    var encodedQuery = use_query_params_1.encodeQueryParams(obj, values);
    return query_string_1.stringify(encodedQuery);
};
exports.createQueryUrl = createQueryUrl;
var getStateNameById = function (id, stateList, lang) {
    var selectedName = '';
    stateList.forEach(function (state) {
        var _a;
        if (state.govId === Number(id)) {
            selectedName = (_a = state.translations[lang]) !== null && _a !== void 0 ? _a : state.text;
        }
    });
    return selectedName;
};
exports.getStateNameById = getStateNameById;
var groupByDistrictsByState = function (array) {
    return array.reduce(function (acc, el) {
        (acc[el.parent_state_id] = acc[el.parent_state_id] || []).push(el);
        return acc;
    }, {});
};
exports.groupByDistrictsByState = groupByDistrictsByState;
var groupByPostAvailability = function (apartments) {
    return apartments.reduce(function (r, a) {
        r[a.availability] = r[a.availability] || [];
        r[a.availability].push(a);
        return r;
    }, Object.create(null));
};
exports.groupByPostAvailability = groupByPostAvailability;
var hasAvailableFreePost = function (apartments) {
    return apartments.some(function (apartment) { return apartment.availability === PostViewContentTypes_1.POST_AVAILABILITY.SALE; });
};
exports.hasAvailableFreePost = hasAvailableFreePost;
var handleFilterStateDistricts = function (state, filters, selectedDistrictsData) {
    var _a;
    var filteredDistrict = [];
    var states = (_a = filters.state) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item !== state; });
    if (!lodash_1.default.isUndefined(states)) {
        selectedDistrictsData.filter(function (district) {
            var _a;
            if (states.includes(String(district.parent_state_id)) &&
                ((_a = filters.district) === null || _a === void 0 ? void 0 : _a.includes(String(district.govId)))) {
                filteredDistrict.push(district.govId);
            }
        });
    }
    return filteredDistrict;
};
exports.handleFilterStateDistricts = handleFilterStateDistricts;
var handleQueryChange = function (prevState, key, value) {
    var filterValues;
    if (prevState[key].includes(value)) {
        filterValues = prevState[key].filter(function (item) { return item !== value; });
    }
    else {
        filterValues = __spreadArray(__spreadArray([], prevState[key]), [value]);
    }
    return filterValues;
};
exports.handleQueryChange = handleQueryChange;
var getStateName = function (filterValue, state) {
    var filter = state.options.find(function (item) { return item.govId === Number(filterValue); });
    return filter.translations.en.toLowerCase();
};
exports.getStateName = getStateName;
var getDistrictName = function (filterValue, districts, currentLanguage) {
    var filter = districts.find(function (item) { return item.govId === Number(filterValue); });
    return exports.concatAddressNameWithPrefix(filter.translations.en, currentLanguage);
};
exports.getDistrictName = getDistrictName;
var concatAddressNameWithPrefix = function (address, language) {
    var splitAddress = address.replace('‑', '-');
    return language === Localization_1.LocalizationSettings.defaultLanguage
        ? [splitAddress.toLowerCase() + 'um']
        : [splitAddress.toLowerCase()];
};
exports.concatAddressNameWithPrefix = concatAddressNameWithPrefix;
var trimAddressNamePrefix = function (address) {
    if (!address || !address.length) {
        return '';
    }
    //@TODO some exception for specific regions
    if (['gyumrium'].includes(address)) {
        var lastIndex = address.lastIndexOf('um');
        return address.slice(0, lastIndex);
    }
    if (['gyumri'].includes(address)) {
        return address;
    }
    return address.toLowerCase().split('um')[0];
};
exports.trimAddressNamePrefix = trimAddressNamePrefix;
var getStateFilteredData = function (address, filters) {
    return filters === null || filters === void 0 ? void 0 : filters.state.options.find(function (item) {
        if (address &&
            item.translations.en.toLowerCase() ===
                exports.trimAddressNamePrefix(address).toLowerCase()) {
            return item;
        }
    });
};
exports.getStateFilteredData = getStateFilteredData;
var getDistrictFilteredData = function (address, selectedDistrictsData) {
    return selectedDistrictsData.find(function (item) {
        var trimmedAddress = address.endsWith('um')
            ? exports.trimAddressNamePrefix(address)
            : address.toLowerCase();
        if (address && item.translations.en.toLowerCase() === trimmedAddress) {
            return item;
        }
    });
};
exports.getDistrictFilteredData = getDistrictFilteredData;
var selectOneFromFilter = function (filter, term) {
    var options = filter.options.map(function (option) {
        var selected = option.text === term;
        return __assign(__assign({}, option), { selected: selected });
    });
    var value = [term];
    return __assign(__assign({}, filter), { options: options,
        value: value });
};
exports.selectOneFromFilter = selectOneFromFilter;
var findElement = function (obj, searchElement, currentLanguage) {
    for (var key in obj) {
        var value = obj[key];
        if (typeof value === 'object') {
            var result = exports.findElement(value, searchElement, currentLanguage);
            if (result) {
                return result;
            }
        }
        else if (value === searchElement) {
            return obj[currentLanguage];
        }
    }
};
exports.findElement = findElement;
